import {IComponentOptions, ILogService} from "angular";
import {Application} from "../../../shared/model/Application";
import {ApplicationService} from "../../../shared/application/application.service";
import {User} from "../../../shared/model/User";

class MyApplicationAssessmentsController {

    public applications: Application[];
    public admin: boolean;
    public currentUser: User;

    /* @ngInject */
    constructor(private $log: ILogService,
                private $state: any,
                private base64: any,
                private applicationService: ApplicationService) {
    }

    public $onInit() {
        this.$log.debug("MyApplicationAssessmentsController.$onInit(): %o", this.admin);
        this.applicationService.getMyAccessingApplications().then((applications) => this.applications = applications);
    }

    public selectApplication(event: any) {
        this.$log.debug("selectApplication", event);

        const currentUserNickname: string = this.currentUser.email.substring(0, this.currentUser.email.indexOf("@")).replace("\.", "");
        const userCheck: string = this.base64.urlencode(currentUserNickname);

        this.$state.go("staff.assessor", {
            applicationId: event.applicationId,
            userCheck: userCheck
        });
    }

}

export const MyApplicationAssessmentsComponent: IComponentOptions = {
    bindings: {
        admin: "<",
        currentUser: "<"
    },
    controller: MyApplicationAssessmentsController,
    template: require("./my-application-assessments.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/staff/dashboard/my-application-assessments/my-application-assessments.component.ts